import { render, staticRenderFns } from "./LoadPagesInfo.vue?vue&type=template&id=4049891a&"
import script from "./LoadPagesInfo.vue?vue&type=script&lang=js&"
export * from "./LoadPagesInfo.vue?vue&type=script&lang=js&"
import style0 from "./LoadPagesInfo.vue?vue&type=style&index=0&id=4049891a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports